export default "__VITE_ASSET__nUeI_NLP__"